import React, { useEffect, useState } from 'react';
import { Pagination } from 'ui-library';

type ClientsPaginationProps = {
    total?: number;
    currentPage?: number;
    pageSize?: number;
    onChange?: (page: number) => void;
};

const ClientsPagination = ({
    total = 0, currentPage = 0, pageSize = 0, onChange = () => null,
}: ClientsPaginationProps) => {
    const [memorizedTotal, setMemorizedTotal] = useState(total);

    useEffect(() => {
        setMemorizedTotal(total !== undefined && total > 0 ? total : 0);
    }, [total]);

    if (!memorizedTotal || memorizedTotal < pageSize) {
        return null;
    }

    return (
        <Pagination
            total={memorizedTotal}
            currentPage={currentPage}
            pageSize={pageSize}
            onChange={onChange}
        />
    );
};

export default ClientsPagination;
